import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActionButtons = ({
  score = 85,
  passingScore = 70,
  canRetake = true,
  nextChapterUnlocked = true,
  currentChapter = 2,
  onRetakeQuiz = () => {},
  showDetailedAnalytics = true
}) => {
  const navigate = useNavigate();
  const isPassed = score >= passingScore;

  const handleRetakeQuiz = () => {
    onRetakeQuiz();
    navigate('/quiz-assessment-interface');
  };

  const handleContinueToNext = () => {
    navigate('/interactive-presentation-viewer');
  };

  const handleBackToDashboard = () => {
    navigate('/chapter-overview-dashboard');
  };

  return (
    <div className="space-y-6">
      {/* Primary Action Section */}
      <div className="p-6 border bg-surface rounded-xl border-border">
        <h3 className="mb-6 text-xl font-bold font-heading text-text-primary">
          What's Next?
        </h3>
        
        <div className="space-y-4">
          {/* Main Action Button */}
          {isPassed && nextChapterUnlocked ? (
            <Button
              variant="primary"
              size="lg"
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
              onClick={handleContinueToNext}
              className="spring-bounce"
            >
              Continue to Chapter {currentChapter + 1}
            </Button>
          ) : (
            <Button
              variant="primary"
              size="lg"
              fullWidth
              iconName="RotateCcw"
              iconPosition="left"
              onClick={handleRetakeQuiz}
              disabled={!canRetake}
            >
              {canRetake ? 'Retake Quiz' : 'Retake Not Available'}
            </Button>
          )}

          {/* Secondary Action */}
          {isPassed && nextChapterUnlocked && canRetake && (
            <Button
              variant="outline"
              size="md"
              fullWidth
              iconName="RotateCcw"
              iconPosition="left"
              onClick={handleRetakeQuiz}
            >
              Retake Quiz to Improve Score
            </Button>
          )}
        </div>
      </div>

      {/* Navigation Actions */}
      {/* <div className="p-6 border bg-surface rounded-xl border-border">
        <h3 className="mb-4 text-lg font-semibold font-heading text-text-primary">
          Navigation
        </h3>
        
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {showDetailedAnalytics && (
            <Link to="/learning-progress-tracker">
              <Button
                variant="secondary"
                size="md"
                fullWidth
                iconName="TrendingUp"
                iconPosition="left"
              >
                Progress Tracker
              </Button>
            </Link>
          )}

          <Button
            variant="ghost"
            size="md"
            fullWidth
            iconName="Home"
            iconPosition="left"
            onClick={handleBackToDashboard}
          >
            Dashboard
          </Button>
        </div>
      </div> */}

      {/* Study Resources */}
      {/* <div className="p-6 border bg-surface rounded-xl border-border">
        <h3 className="mb-4 text-lg font-semibold font-heading text-text-primary">
          Study Resources
        </h3>
        
        <div className="space-y-3">
          <Link to="/interactive-presentation-viewer">
            <Button
              variant="outline"
              size="sm"
              fullWidth
              iconName="BookOpen"
              iconPosition="left"
            >
              Review Chapter Content
            </Button>
          </Link>
          
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            iconName="FileText"
            iconPosition="left"
            onClick={() => {
              // Mock functionality for study notes
              alert("Study notes feature coming soon!");
            }}
          >
            Download Study Notes
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            iconName="HelpCircle"
            iconPosition="left"
            onClick={() => {
              // Mock functionality for help
              alert("Help and support feature coming soon!");
            }}
          >
            Get Help & Support
          </Button>
        </div>
      </div> */}

      {/* Recommendation Based on Performance */}
      {/* {!isPassed ? (
        <div className="p-6 border bg-warning-50 rounded-xl border-warning-200">
          <div className="flex items-start space-x-3">
            <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg bg-warning-100">
              <Icon name="BookOpen" size={16} color="var(--color-warning)" strokeWidth={2} />
            </div>
            <div>
              <h4 className="mb-2 font-semibold font-heading text-warning-800">
                Study Recommendations
              </h4>
              <p className="mb-4 text-sm text-warning-700">
                Review the chapter material and focus on the areas where you missed questions. 
                Take your time to understand the concepts before retaking the quiz.
              </p>
              <div className="flex flex-col gap-2 sm:flex-row">
                <Link to="/interactive-presentation-viewer">
                  <Button
                    variant="warning"
                    size="sm"
                    iconName="BookOpen"
                    iconPosition="left"
                  >
                    Review Content
                  </Button>
                </Link>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Clock"
                  iconPosition="left"
                  onClick={() => {
                    alert("Practice mode coming soon!");
                  }}
                >
                  Practice Mode
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="p-6 border bg-success-50 rounded-xl border-success-200">
          <div className="flex items-start space-x-3">
            <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg bg-success-100">
              <Icon name="Trophy" size={16} color="var(--color-success)" strokeWidth={2} />
            </div>
            <div>
              <h4 className="mb-2 font-semibold font-heading text-success-800">
                Excellent Work!
              </h4>
              <p className="mb-4 text-sm text-success-700">
                {nextChapterUnlocked 
                  ? `You've successfully completed this chapter! Continue to Chapter ${currentChapter + 1} to build on your knowledge.`
                  : "Great job completing this assessment! Review your progress and explore additional resources."
                }
              </p>
              {nextChapterUnlocked && (
                <Button
                  variant="success"
                  size="sm"
                  iconName="ArrowRight"
                  iconPosition="right"
                  onClick={handleContinueToNext}
                >
                  Continue Learning
                </Button>
              )}
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ActionButtons;